/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { UseMutationResult } from '@tanstack/react-query'
import { Group, Loader, Modal, Text } from '@mantine/core'

export type UploadingModalProps = {
  uploader: UseMutationResult
}

function UploadingModal (props: UploadingModalProps) {
  const { uploader } = props
  return (
    <>
      <Modal
        centered
        onClose={() => {
          // do nothing
        }}
        opened={uploader.isPending}
        title={<FormattedMessage
          id="uploading"
          defaultMessage="Transfert en cours..."
        />}
      >
        <Group>
          <Loader />
          <Text>
            <FormattedMessage
              id="please_wait_during_upload"
              defaultMessage="Veuillez patienter pendant le transfert du fichier."
            />
          </Text>
        </Group>
      </Modal>
    </>
  )
}

export default UploadingModal
